import React, { useEffect } from "react";
import { Route, Switch, useLocation, useHistory } from "react-router-dom";
import "./App.scss";
import { useSelector } from "react-redux";
import Enrollment from "./enrollment/enrollment";
import CoursePage from "./course/course.page";
import CourseConsentPage from "./course-consent/course-consent.page";
import BackgroundPage from "./background/background.page";
import { AccountCommander } from "../store/commanders/account.commander";
import Account from "./account/account";
import PaymentPage from "./payment/payment";
import CouponRedeemedPage from "./coupon-redeemed/coupon-redeemed.page";

const App = () => {
  let location: any = useLocation();
  const user = useSelector((state: any) => state.application.user);
  let history = useHistory();

  const userData = useSelector((state: any) => state.account.userData);
  useEffect(() => {
    AccountCommander.cmd_get_account();
  }, []);

  useEffect(() => {
    const managedRoutes = [
      "/account",
      "/background",
      "/course",
      "/course-consent",
      "/payment",
      "/coupon-redeemed",
    ];

    if (
      userData &&
      Object.keys(userData).length &&
      userData.enrolled &&
      !managedRoutes.includes(location.pathname)
    ) {
      history.push(
        (userData.valid_subscription && !location.state?.recertify) ||
          userData.state === "AL"
          ? "/course"
          : "/payment"
      );
    }
  }, [userData.enrolled, location.pathname, userData.valid_subscription]);

  return (
    <div className="app-container">
      <Switch>
        <Route path={`/account`} component={Account} />
        <Route path={`/background`} component={BackgroundPage} />
        <Route path={`/course-consent`} component={CourseConsentPage} />
        <Route path={`/course`} component={CoursePage} />
        <Route path={`/enrolment`} component={Enrollment} />
        <Route path={`/payment`} component={PaymentPage} />
        <Route path={`/coupon-redeemed`} component={CouponRedeemedPage} />
        <Route component={Enrollment} />
      </Switch>
    </div>
  );
};

export default App;
